// extracted by mini-css-extract-plugin
module.exports = {"form":"DownloadPDFForm_form__CI_qR","button":"DownloadPDFForm_button__cXjkt"};